import { render, staticRenderFns } from "./PrismEditor.vue?vue&type=template&id=3de4ffc7"
import script from "./PrismEditor.vue?vue&type=script&lang=js"
export * from "./PrismEditor.vue?vue&type=script&lang=js"
import style0 from "./PrismEditor.vue?vue&type=style&index=0&id=3de4ffc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports